if (!customElements.get('bb-birthstone-picker')) {
  customElements.define('bb-birthstone-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.buttons = [...this.querySelectorAll('[data-month]')];
      this.groups = [...this.querySelectorAll('[data-group]')];
      this.currentVariants = JSON.parse(this.querySelector('[data-current-variants]').textContent);
      this.currentOptions = JSON.parse(this.querySelector('[data-current-options]').textContent);
      this.materialIndex = this.currentOptions.findIndex(name => /material|metal|metall|matériau|matériaux|материал/i.test(name));
      const active = this.querySelector('[aria-current="page"]');
      this.select(active?.closest('[data-group]').dataset.group || 'all');
      this.querySelector('.bb-birthstone__months').hidden = false;
      this.buttons.forEach(button => button.addEventListener('click', () => this.select(button.dataset.month)));
      this.querySelectorAll('[data-sibling]').forEach(link => {
        const update = () => {
          const url = new URL(link.getAttribute('href'), location.origin);
          const context = new URL(location.href);
          const preview = context.searchParams.get('preview_theme_id');
          if (preview) url.searchParams.set('preview_theme_id', preview);
          url.searchParams.delete('variant');
          const productInfo = this.closest('product-info') || this.closest('.shopify-section');
          const variantId = productInfo?.querySelector('form[action*="/cart/add"] [name="id"]')?.value || context.searchParams.get('variant');
          const current = this.currentVariants.find(variant => String(variant.id) === String(variantId));
          if (current && this.materialIndex >= 0) {
            const variants = JSON.parse(link.querySelector('[data-variants]').textContent);
            const material = current.options[this.materialIndex];
            const sameOptions = variants.find(variant => variant.available && variant.options.every((option, i) => option === current.options[i]));
            const matching = sameOptions || variants.find(variant => variant.available && variant.options.includes(material));
            if (matching) url.searchParams.set('variant', matching.id);
          }
          link.href = url.pathname + url.search;
        };
        link.addEventListener('pointerdown', update);
        link.addEventListener('focus', update);
        link.addEventListener('click', update);
      });
    }
    select(month) {
      if (month === '13') month = 'all';
      this.buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.month === month)));
      this.groups.forEach(group => { group.hidden = month !== 'all' && group.dataset.group !== month; });
    }
  });
}
